export default "__VITE_ASSET__de315f2e__"